import React, { useEffect, useState } from "react";
import ButtonGeneric from "../../../../../components/Buttons/ButtonGeneric";
import bills from "../../../../../assets/png/bill.png";
import logo from "../../../../../assets/bancos/newLogos/mercantil-50.png"
import {
  formPagoMercantilTDC,
  optionAnoMercantil,
  optionMes,
  optionPyment
} from "../../../../../propsType/Payemnts";
import { validatePagoMercantilTDC } from "../../../../../validations/formValidations";
import { useForm } from "../../../../../Hooks/UseForm";
import PagosController from "../../../../../controllers/PagosController";
import SelectGeneric from "../../../../../components/Inputs/SelectGeneric";
import InputGeneric from "../../../../../components/Inputs/InputGeneric";
import Spinner from "../../../../../components/Loading/loadingSpinner/Spinner";
import Modal from "../../../../../components/Modals/Modal";
import { useLocation } from "react-router-dom";
import moment from "moment";
import visa from "../../../../../assets/bancos/newLogos/visa-50.png";
import mastercard from "../../../../../assets/bancos/newLogos/mastercard-50.png";
import { UseContextApp } from "../../../../../Global/Context/appContext";

function MercantilTDC({
  data,
  setData,
  stapsState,
  setStapsState,
  back,
  deatils,
  bankInfo,
}) {
  const [{ user }] = UseContextApp();
  const [stepsPayment, setStepsPayment] = useState(false);
  const { mercantilPagoTDC, solicitarOtp } = PagosController();
  const [activeModal, setActiveModal] = useState(false);
  const [check, setCheck] = useState(false);
  const [message, setMessage] = useState("");
  const location = useLocation();
  const [showNroTDC, setShowNroTDC] = useState(false);
  const [showCVV, setShowCVV] = useState(false);
  const [fechaNow, setFechaNow] = useState(moment().format("YYYY-MM-DD"));

  const [sendSms, setSendSms] = useState(true);
  const [sendEmail, setSendEmail] = useState(false);
  const [loadingOtp, setLoadingOtp] = useState(false);
  const [otpSent, setOtpSent] = useState(false);

  const {
    form,
    errors,
    setErrors,
    handleChange,
    handleSubmit,
    handleBlur
  } = useForm(
    formPagoMercantilTDC,
    validatePagoMercantilTDC
  );
  const [loading, setLoading] = useState(false);

  const handleSolicitarOtp = async () => {
    if (!sendSms && !sendEmail) {
      setCheck(false);
      setMessage("Debe seleccionar al menos un método de envío (SMS o Correo).");
      setActiveModal(true);
      return;
    }

    try {
      setLoadingOtp(true);
      const emailRaw = user?.datos?.email || user?.email || "";
      const correoBase64 = emailRaw ? btoa(unescape(encodeURIComponent(emailRaw))) : "";
      const payload = {
        docIdentidad: (user?.datos?.docIdentificacion || user?.id || user?.idCliente || "").toString(),
        tipoOtp: 1,
        correo: correoBase64,
      };

      if (sendSms && !sendEmail) {
        payload.canal = "sms";
      } else if (!sendSms && sendEmail) {
        payload.canal = "correo";
      }

      const res = await solicitarOtp(payload);
      setLoadingOtp(false);

      if (res?.respuesta === "0" || res?.codigo === "0" || res?.codRespuesta === "0") {
        setCheck(true);
        setMessage(res.descripcion || "Para continuar, hemos enviado un código de seguridad.");
        setActiveModal(true);
        setOtpSent(true);
      } else {
        setCheck(false);
        setMessage(res?.descripcion || "Ha ocurrido un error al solicitar el código OTP. Intente nuevamente.");
        setActiveModal(true);
      }
    } catch (error) {
      setLoadingOtp(false);
      setCheck(false);
      setMessage("Ha ocurrido un error al procesar la solicitud de OTP.");
      setActiveModal(true);
    }
  };

  const pagar = async () => {
    const result = handleSubmit();
    if (result === "ok") {
      setLoading(true);
      let newObjet =
      {
        nroTarjeta: form.numberCardCredit,
        docIdentidad: form.selectDoc + form.typeDoc,
        fechaExpiracion:
          form.year + "/" + form.month,
        cvv: form.code,
        amount: data.metodoAPagar,
        nroCuenta: location.state.data.nroCuenta,
        otp: form.otp,
      };
      const res = await mercantilPagoTDC(newObjet);
      switch (res.respuesta) {
        case "0":
          setStapsState({
            ...stapsState,
            option1: false,
            option2: false,
            option3: false,
            option4: false,
            option5: true,
          });
          setData({
            ...data,
            transaccion: Math.round(Math.random() * 10000000000), monto: data.metodoAPagar, fecha: fechaNow
          });
          break;
        default:
          setLoading(false);
          setCheck(false);
          setActiveModal(true);
          if (res?.status == 3) {
            setMessage("Por favor, verifica los dígitos del código que recibiste e ingrésalo nuevamente.");
          } else if (res?.status == 4) {
            setMessage("Has completado las 3 transacciones permitidas. Puedes intentarlo nuevamente el próximo mes.");
          } else {
            setMessage(res?.descripcion || "Ha ocurrido un error inesperado, por favor inténtelo de nuevo...");
          }
          break;

      }
    }
  }
  const closetModal = () => {
    setActiveModal(false);
    setMessage("");
  };
  function filtro(e) {
    if (form.selectDoc !== "P") {
      var tecla = e.key;
      if (['.', 'e', 'E'].includes(tecla))
        e.preventDefault()
    }
  }
  const funtionShowCVV = () => { setShowCVV(!showCVV); };
  const funtionShowNroTDC = () => { setShowNroTDC(!showNroTDC); };

  return (
    <>
      <div className="flex lg:pt-[125px] pt-[220px] flex-col-reverse px-5 pb-6 lg:flex-row lg:pb-7  lg:px-[28px] gap-4 relative">
        <div className="lg:w-[70%]  ">
          {loading ? (
            <>
              <div className="w-full h-full flex justify-center items-center">
                <Spinner title={"Solicitud en Proceso. Espere por favor..."} />
              </div>
            </>
          ) : (
            <>
              <div className="absolute left-0 top-0 w-full ">
                <div className="bg-white w-full px-4 py-5 border-b border-gray-200 sm:px-6">
                  <div className="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
                    <div className="ml-4 mt-4">
                      <h3 className="text-2xl leading-6 font-medium text-gray-900">
                        Pagar
                      </h3>
                      <p className="mt-1 text-sm text-gray-500">
                        Completa la información y haz clic en pagar
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="h-full flex flex-col gap-5 justify-between lg:pr-[50px] ">
                <div className="grid lg:gap-[20px] gap-6 lg:relative lg:-top-[25px]">
                  <div className="flex justify-center flex-col lg:flex-row items-center gap-5">
                    <div className="w-full">
                      <InputGeneric
                        title={"Número de Tarjeta"}
                        name={"numberCardCredit"}
                        value={form.numberCardCredit}
                        errorText={errors.numberCardCredit}
                        onChange={handleChange}
                        handleBlur={handleBlur}
                        maxValue={16}
                        type={showNroTDC ? "text" : "password"}
                        show={showNroTDC}
                        funtionShow={funtionShowNroTDC}
                      />
                    </div>

                    <div className="grid w-full">
                      <div className="grid !mt-1  grid-cols-7">

                      </div>
                    </div>
                  </div>
                  <div className="flex justify-center flex-col lg:flex-row items-center gap-5">
                    <div className="w-full">
                      <div className="text-sm font-medium text-gray-900">
                        Documento de Identidad
                      </div>
                      <div className="grid !mt-1  grid-cols-7">
                        <div className="col-span-2">
                          <SelectGeneric
                            onChange={handleChange}
                            value={form.selectDoc}
                            name={"selectDoc"}
                            onBlur={handleBlur}
                            errors={errors.selectDoc}
                            selectData={optionPyment}
                          />
                        </div>
                        <div className="col-span-5">
                          <InputGeneric
                            name={"typeDoc"}
                            type={form?.selectDoc === "P" ? "text" : "number"}
                            onKeyDown={(e) => filtro(e)}
                            maxValue={13}
                            value={form.typeDoc}
                            onChange={handleChange}
                            handleBlur={handleBlur}
                            errorText={errors.typeDoc}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="grid w-full">
                    </div>
                  </div>
                  <div className="w-full flex justify-between flex-col lg:flex-row items-center gap-5 ">
                    <div className="flex w-full flex-col gap-3">
                      <div className="flex gap-5 ">
                        <div className="grid w-full ">
                          <div className="text-sm font-medium text-gray-900">
                            Mes de Vencimiento
                          </div>
                          <div className="grid !mt-1 ">
                            <SelectGeneric
                              onChange={handleChange}
                              value={form.month}
                              name={"month"}
                              onBlur={handleBlur}
                              errors={errors.month}
                              selectData={optionMes}
                            />
                          </div>
                        </div>
                        <div className="grid w-full ">
                          <div className="text-sm font-medium text-gray-900">
                            Año de Vencimiento
                          </div>
                          <div className="grid !mt-1 ">
                            <SelectGeneric
                              onChange={handleChange}
                              value={form.year}
                              name={"year"}
                              onBlur={handleBlur}
                              errors={errors.year}
                              selectData={optionAnoMercantil}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-full">
                    </div>
                  </div>
                  <div className="w-full flex justify-between flex-col lg:flex-row items-center gap-5 ">
                    <div className="flex w-full flex-col gap-3">
                      <div className="w-full">
                        <InputGeneric
                          title={"Código de Seguridad (CVV)"}
                          name={"code"}
                          handleBlur={handleBlur}
                          onChange={handleChange}
                          errorText={errors.code}
                          value={form.code}
                          type={showCVV ? "text" : "password"}
                          show={showCVV}
                          funtionShow={funtionShowCVV}
                          maxValue={3}
                        />
                      </div>
                    </div>
                    <div className="w-full"></div>
                  </div>

                  {/* Sección Método de Envío OTP */}
                  <div className="flex flex-col gap-2 pt-1">
                    <div className="text-sm font-medium text-gray-900">
                      Seleccione el método de envío de OTP:
                    </div>
                    <div className="flex flex-col gap-3 mt-1">
                      <label className="flex items-center gap-3 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={sendSms}
                          onChange={(e) => setSendSms(e.target.checked)}
                          className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded cursor-pointer"
                        />
                        <span className="text-sm font-normal text-gray-700 min-w-[160px]">
                          Teléfono (SMS)
                        </span>
                        <span className="text-sm font-medium text-gray-800 tracking-wide">
                          {user?.datos?.maskTelefono || (user?.datos?.telefono ? user.datos.telefono.replace(/(\d{4})\d+(\d{2})/, "$1-****$2") : "+58 424 *** **12")}
                        </span>
                      </label>
                      <label className="flex items-center gap-3 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={sendEmail}
                          onChange={(e) => setSendEmail(e.target.checked)}
                          className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded cursor-pointer"
                        />
                        <span className="text-sm font-normal text-gray-700 min-w-[160px]">
                          Correo Electrónico
                        </span>
                        <span className="text-sm font-medium text-gray-800 tracking-wide">
                          {user?.datos?.maskEmail || user?.datos?.email || "u***r@dominio.com"}
                        </span>
                      </label>
                    </div>
                  </div>

                  {/* Sección Input OTP y Botón Solicitar */}
                  <div className="flex flex-col gap-2 pt-2">
                    <div className="text-sm font-medium text-gray-900">
                      Ingrese el código de seguridad recibido:
                    </div>
                    <div className="flex flex-wrap sm:flex-nowrap items-start gap-4">
                      <div className="w-full sm:w-[220px]">
                        <InputGeneric
                          placeholder={""}
                          name={"otp"}
                          type={"text"}
                          handleBlur={handleBlur}
                          onChange={handleChange}
                          errorText={errors.otp}
                          value={form.otp}
                          maxValue={8}
                        />
                      </div>
                      <button
                        type="button"
                        disabled={loadingOtp || (!sendSms && !sendEmail)}
                        onClick={handleSolicitarOtp}
                        className="bg-[#00529C] hover:bg-[#003d75] disabled:bg-gray-400 text-white font-medium text-sm px-6 py-[11px] rounded shadow transition-all duration-200 mt-[2px] whitespace-nowrap"
                      >
                        {loadingOtp ? "Solicitando..." : "Solicitar OTP"}
                      </button>
                    </div>
                  </div>

                  <p className="text-[0.8rem] text-[#798791] mt-2">
                    Importante: Por favor verifique que los datos suministrados de su tarjeta sean exactos para que su transacción sea exitosa.
                  </p>
                  <hr />
                </div>
                <div className="w-full mt-5 flex justify-between items-center gap-[50%]">
                  <div className="w-full">
                    <ButtonGeneric funtion={back} text={"Volver"} />
                  </div>
                  <div className="w-full">
                    <ButtonGeneric
                      funtion={pagar}
                      text={"Pagar"}
                      disable={!form.otp || form.otp.toString().trim().length < 6}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        <div className="lg:w-[30%] relative sha">
          <div
            className="bg-[#005dff0a] w-full h-[400px] relative flex justify-center rounded-[5%]   
                            before:content-[''] 
                            before:absolute 
                            before:w-[45px] 
                            before:h-[45px] 
                            before:rounded-full 
                            before:bg-white 
                            before:bottom-[-20px]
                            before:left-[-20px]
                            after:content-[''] 
                            after:absolute 
                            after:w-[45px] 
                            after:h-[45px] 
                            after:rounded-full 
                            after:bg-white 
                            after:bottom-[-20px]
                            after:right-[-20px] 
            "
          >
            <div
              className={` bg-[url("../public/bgCard.jpg")] bg-right w-[80%] bg-auto bg-no-repeat flex flex-col justify-between absolute lg:w-[80%] h-[85%] shadow-xl rounded-[10%] top-[-25%] z-[10] p-[2rem]`}
            >
              <div className="flex w-full justify-center absolute top-0  right-0  ">
                <div className="border-blue-500 border-2 shadow-xl w-[30%] shadowTarjet shadow-blue-500 "></div>
              </div>
              <div className="flex justify-center  items-center gap-5">
                <img className="w-[80px] " src={visa} alt="" />
                <img className="w-[80px] " src={mastercard} alt="" />
              </div>
              <div className="h-40% grid gap-[10px]">
                <div className="font-medium text-center">
                  {"Crédito Nacional"}{" "}
                </div>
                <div className="flex flex-col justify-between items-center">
                  <div className="font-medium text-center ">
                    {" "}
                    <div className="whitespace-nowrap">
                      Número de cuenta
                    </div>{" "}
                  </div>
                  <div className="text-center"> {deatils.nroCuenta} </div>
                </div>
                <div className="flex flex-col justify-between items-center">
                  <div className="font-medium w-full text-center">Moneda</div>
                  <div className=" w-full text-center">
                    {data?.data?.title}{" "}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col justify-end w-full p-5 gap-4">
              <div className="flex justify-between ">
                <div className="text-[#798791] "> {
                  deatils?.deudaTotalVEF < "0" || deatils?.deudaTotalUSD < "0" ?
                    (
                      <>
                        Saldo a favor
                      </>
                    )
                    :
                    (
                      <>
                        Saldo
                      </>
                    )
                }</div>
                <div className="font-medium">Bs {deatils?.deudaTotalVEF}</div>
              </div>
            </div>
          </div>
          <div className="w-full flex justify-center ">
            <div className="w-[80%] border-dashed  border-t-[2px] border-[#c8c8c8]"></div>
          </div>

          <div className="bg-[#005dff0a] h-[100px] rounded-[10%]">
            <div className="w-full p-5 flex justify-between items-center">
              <div>
                <div>
                  <div className="text-[#798791] ">Monto a Pagar</div>
                  <div className="text-2xl font-medium">
                    <span className="text-[#798791] pr-2 ">Bs</span>
                    {data?.metodoAPagar}
                  </div>
                </div>
              </div>
              <div className="w-[35px] ">
                <img src={bills} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        string={check ? "check" : "error"}
        message={message}
        active={activeModal}
        setActive={setActiveModal}
      >
        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
          <div className="flex  flex-col gap-2 ">
            <button
              type="button"
              onClick={closetModal}
              className={` ${check ? "bg-green-500" : "bg-red-500"
                } inline-flex w-full justify-center rounded-md  px-3 py-2 text-sm font-semibold text-white shadow-sm  sm:ml-3 sm:w-auto`}
            >
              Cerrar
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default MercantilTDC;
